module.exports = __webpack_public_path__ + "img/12.1de37c52.png";